module.exports = __webpack_public_path__ + "img/delete_icon_dark.36ee31f6.svg";